
import { selector } from '~/mixins/selector'

export default {
  mixins: [selector],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '#research-loop-diagram',
          start: 'center bottom',
          // markers: true,
        },
      })
      tl.from('#path-9-inside-1_5559_38815', {
        fill: 'transparent',
      })

      tl.from('#paint2_linear_5559_38815 stop', {
        duration: 0.3,
        attr: { offset: '0' },
        ease: 'none',
      })

      tl.fromTo(
        this.selector('.arrow'),
        {
          opacity: 0,
          drawSVG: '0',
        },
        {
          opacity: 1,
          drawSVG: '100%',
          duration: 0.5,
        }
      )
    },
  },
}
